import { HTMLAttributes } from "react";
import { useTranslation } from "react-i18next";
import { cn } from "@/core/helpers/cn";
import { LockIcon } from "@/shared/icons";

type Props = HTMLAttributes<HTMLButtonElement>;

export default function TransportWarehouseTransportUnlockSlotButton({ className, ...rest }: Props) {
  const { t } = useTranslation("transportWarehouse");

  return (
    <button
      type="button"
      className={cn(
        "relative h-[15.75rem] flex flex-col items-center justify-center gap-3.5 p-2.5 bg-dark-800/20 rounded-[0.75rem] cursor-pointer",
        "text-10 font-bold uppercase text-white/50",
        "border border-dashed border-[#1A1A1A] hover:border-[#FF4E4E]/20 rounded-[0.75rem] transition-[border-color]",
        "group overflow-clip",
        className,
      )}
      {...rest}
      data-mz-accent="olive"
    >
      <div
        className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-opacity"
        style={{
          background:
            "linear-gradient(180deg, rgba(171, 41, 41, 0.03) 0%, rgba(171, 41, 41, 0.10) 100%)",
        }}
      />
      <LockIcon size={38} className="z-1 text-[#FF4E4E]" />
      <div className="z-1 text-10 font-bold text-white/50 group-hover:text-[#FF4E4E] uppercase transition-[color]">
        {t("transportWarehouse.unlockSlot")}
      </div>
    </button>
  );
}
